function waitForjQuery(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
waitForjQuery(function () {
  $(document).on("click", ".faq-question", function () {
    const next_sibling = $(this).next();
    $(".faq-answer").not(next_sibling).stop().slideUp();
    $(".faq-question").not(this).removeClass("active");
    $(this).toggleClass("active").next().stop().slideToggle();
  });
  // $(document).on("click", ".faq-blocks-wrapper .show-more-faq", function () {
  //   console.log(1);
  // });
});
document.querySelector(".show-more-faq").addEventListener("click", function () {
  $(".faq-question:nth-child(5),.faq-question:nth-child(7)").css({
    display: "flex",
  });
  $(this).css("display", "none");
});
